import { CircleAlert } from "lucide-react";

export interface Requirement {
  met: boolean;
  label: string;
}

/**
 * Names what is still missing next to a disabled guarded action. The typed
 * confirmation phrases stay mandatory; this only explains why the button is inert
 * instead of leaving the operator to guess.
 */
export function FormRequirements({ requirements, className }: { requirements: Requirement[]; className?: string }) {
  const outstanding = requirements.filter((requirement) => !requirement.met);
  if (outstanding.length === 0) return null;
  return (
    <p className={className ? `form-requirements ${className}` : "form-requirements"} role="status">
      <CircleAlert size={13} aria-hidden="true" />
      <span>Still needed: {outstanding.map((requirement) => requirement.label).join(" · ")}</span>
    </p>
  );
}
